var version = "1.2.0" || 'unknown';

/** */

/**
 * Format tracker objects
 */
export default function tracker(input) {
  var _ref = input || {},
    trackerData = _ref.tracker;
  return Object.assign({
    name: 'Pulse Node.js SDK',
    type: 'JS',
    eventBuilderVersion: version
  }, trackerData);
}
export function defaultValue() {}